// components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer
      style={{
        background: "#0A0A0A",
        borderTop: "1px solid rgba(201,168,76,0.12)",
        padding: "4rem 0 2rem",
      }}
    >
      <div className="container">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
            gap: "3rem",
            marginBottom: "3rem",
          }}
        >
          <div>
            <div
              style={{
                fontFamily: "Cormorant Garamond,serif",
                fontSize: "1.6rem",
                color: "#C9A84C",
                fontWeight: 700,
                marginBottom: "0.75rem",
              }}
            >
              NirmalRam
            </div>
            <p
              style={{
                color: "#5A5450",
                fontSize: "0.9rem",
                lineHeight: 1.8,
                marginBottom: "1rem",
              }}
            >
              Building dream homes with precision, trust, and quality
              craftsmanship since 2022.
            </p>
            <p style={{ color: "#8A8070", fontSize: "0.85rem" }}>
              📍 Nandurbar, Maharashtra
            </p>
          </div>
          <div>
            <h4
              style={{
                color: "#C9A84C",
                fontSize: "0.75rem",
                letterSpacing: "2px",
                textTransform: "uppercase",
                marginBottom: "1.25rem",
              }}
            >
              Quick Links
            </h4>
            {[
              ["/", "Home"],
              ["/services", "Services"],
              ["/projects", "Projects"],
              ["/videos", "Videos"],
              ["/about", "About Us"],
              ["/contact", "Contact"],
            ].map(([to, label]) => (
              <Link
                key={to}
                to={to}
                style={{
                  display: "block",
                  color: "#5A5450",
                  fontSize: "0.9rem",
                  marginBottom: "0.6rem",
                  transition: "color 0.2s",
                }}
                onMouseEnter={(e) => (e.target.style.color = "#C9A84C")}
                onMouseLeave={(e) => (e.target.style.color = "#5A5450")}
              >
                {label}
              </Link>
            ))}
          </div>
          <div>
            <h4
              style={{
                color: "#C9A84C",
                fontSize: "0.75rem",
                letterSpacing: "2px",
                textTransform: "uppercase",
                marginBottom: "1.25rem",
              }}
            >
              Services
            </h4>
            {[
              "Residential Construction",
              "Home Renovation",
              "Borwell Drilling",
              "Painting & Finishing",
              "Lenting Work",
              "Government Contracts",
            ].map((s) => (
              <p
                key={s}
                style={{
                  color: "#5A5450",
                  fontSize: "0.88rem",
                  marginBottom: "0.5rem",
                }}
              >
                {s}
              </p>
            ))}
          </div>
          <div>
            <h4
              style={{
                color: "#C9A84C",
                fontSize: "0.75rem",
                letterSpacing: "2px",
                textTransform: "uppercase",
                marginBottom: "1.25rem",
              }}
            >
              Contact
            </h4>
            <p
              style={{
                color: "#5A5450",
                fontSize: "0.9rem",
                marginBottom: "0.75rem",
              }}
            >
              📞 +91 9403646276
            </p>
            <p
              style={{
                color: "#5A5450",
                fontSize: "0.9rem",
                marginBottom: "0.75rem",
              }}
            >
              ✉ nirmalramconstruction@gmail.com
            </p>
            <p
              style={{
                color: "#5A5450",
                fontSize: "0.9rem",
                marginBottom: "1.5rem",
              }}
            >
              ⏰ Mon–Sat: 9am – 7pm
            </p>
            <a
              href="https://wa.me/919403646276"
              target="_blank"
              rel="noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem",
                background: "#25D366",
                color: "#fff",
                padding: "0.6rem 1.2rem",
                borderRadius: "3px",
                fontSize: "0.85rem",
                fontWeight: 600,
              }}
            >
              💬 WhatsApp Us
            </a>
          </div>
        </div>
        <div
          style={{
            borderTop: "1px solid rgba(201,168,76,0.1)",
            paddingTop: "1.5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          <p style={{ color: "#3A3430", fontSize: "0.82rem" }}>
            © 2025 NirmalRam Construction. All rights reserved.
          </p>
          <p style={{ color: "#3A3430", fontSize: "0.82rem" }}>
            Founded by Hitesh Patil (B.Tech Civil, 2021)
          </p>
        </div>
        <div>
          <p style={{ color: "#3A3430", fontSize: "0.82rem" }}>
            Design and Developed By: Sudarshan Patil
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

// components/WhatsAppBtn.jsx
export function WhatsAppBtn() {
  return (
    <a
      href="https://wa.me/919403646276?text=Hello%20NirmalRam%20Construction%2C%20I%20am%20interested%20in%20your%20services."
      target="_blank"
      rel="noreferrer"
      title="Chat on WhatsApp"
      style={{
        position: "fixed",
        bottom: "1.75rem",
        right: "1.75rem",
        zIndex: 900,
        width: "56px",
        height: "56px",
        borderRadius: "50%",
        background: "#25D366",
        color: "#fff",
        fontSize: "1.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 24px rgba(37,211,102,0.4)",
        transition: "transform 0.2s, box-shadow 0.2s",
        textDecoration: "none",
        animation: "pulse-gold 2s infinite",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      💬
    </a>
  );
}

// components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
}
